import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import FilterByKeySearchDto from '@/service/dataLogKibanaDto/FilterByKeySearchDto';

import localStorageUtil from '@/common/utils/localStorageUtil';
import sessionStorageUtil from '@/common/utils/sessionStorageUtil';
import { v4 as uuidv4} from 'uuid';

import FilterByTagSuggestDto from '@/service/dataLogKibanaDto/FilterByTagSuggestDto';
import FilterByDrillDownDto from '@/service/dataLogKibanaDto/FilterByDrillDownDto';
import FilterByViewChangeDto from '@/service/dataLogKibanaDto/FilterByViewChangeDto';
import FilterByTagRemoveDto from '@/service/dataLogKibanaDto/FilterByTagRemoveDto';
import FilterByCategorySelectDto from '@/service/dataLogKibanaDto/FilterByCategorySelectDto';
import KnowledgeRoboSelectTagGroupDto from '@/service/dataLogKibanaDto/KnowledgeRoboSelectTagGroupDto';
import KnowledgeRoboSelectTagDto from '@/service/dataLogKibanaDto/KnowledgeRoboSelectTagDto';
import ContentOperationViewDto from '@/service/dataLogKibanaDto/ContentOperationViewDto';
import ContentOperationCreateDto from '@/service/dataLogKibanaDto/ContentOperationCreateDto';
import KnowledgeRoboClickKnowledgeDto from '@/service/dataLogKibanaDto/KnowledgeRoboClickKnowledgeDto';
import ChatOnCustomerDto from '@/service/dataLogKibanaDto/ChatOnCustomerDto';
import ChatOnProjectDto from '@/service/dataLogKibanaDto/ChatOnProjectDto';
import ChatOnEscalationDto from '@/service/dataLogKibanaDto/ChatOnEscalationDto';
import ChatOnKnowledgeDto from '@/service/dataLogKibanaDto/ChatOnKnowledgeDto';
import InteractChatAIDto from '@/service/dataLogKibanaDto/InteractChatAIDto';
import ReferencesAsAIPromptDto from '@/service/dataLogKibanaDto/ReferencesAsAIPromptDto';
import KnowLedgeRoboEnqueteDto from '@/service/dataLogKibanaDto/KnowLedgeRoboEnqueteDto';

import ChatAISearchConditionSettingDto from '@/service/dataLogKibanaDto/ChatAISearchConditionSettingDto';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import moment from 'moment';
import { buildDrillDownSearchParam } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import trI18n from '@/common/utils/trI18n';

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

const getSession = () => {
    const isLogined = localStorageUtil.getItem('amplify-authenticator-authState') === 'signedIn';
    const session = isLogined
        ? localStorageUtil.getSessionBrowserId()
        : sessionStorageUtil.getSessionBrowserId();

    return session;
}

export const createKibanaData = (
    lastUserAction,
    filterInput,
    keywordList,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    searchContentType,
    operationScreen,
    tagSuggestList,
    inforSearch,
    removedTagItem
) => {
    if (!lastUserAction) {
        return;
    }

    switch (lastUserAction) {
        case LogKibanaConstant.SEARCH_ACTION.KEY_WORD:
            return createKibanaKeySearchData(
                filterInput,
                keywordList,
                corporationDetail,
                projectInuseDetail,
                userDetail,
                searchContentType,
                operationScreen,
                inforSearch,
                tagSuggestList
            );
        case LogKibanaConstant.SEARCH_ACTION.TAG_SUGGEST:
            return createKibanaTagSuggestData(
                filterInput,
                tagSuggestList,
                corporationDetail,
                projectInuseDetail,
                userDetail,
                searchContentType,
                operationScreen,
                inforSearch,
                keywordList
            );
        case LogKibanaConstant.SEARCH_ACTION.DRILL_DOWN:
            return createKibanaDrillDownData(
                filterInput,
                tagSuggestList,
                corporationDetail,
                projectInuseDetail,
                userDetail,
                searchContentType,
                operationScreen,
                inforSearch,
                keywordList
            );
        case LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE:
            return createKibanaViewChangeData(
                filterInput,
                tagSuggestList,
                corporationDetail,
                projectInuseDetail,
                userDetail,
                searchContentType,
                operationScreen,
                inforSearch,
                keywordList
            );
        case LogKibanaConstant.SEARCH_ACTION.TAG_REMOVE:
            return createKibanaRemoveTag(
                filterInput,
                keywordList,
                corporationDetail,
                projectInuseDetail,
                userDetail,
                searchContentType,
                operationScreen,
                tagSuggestList,
                inforSearch,
                removedTagItem
            );
        default:
            break;
    }
};

export const createKibanaKeySearchData = (filterInput, keywordList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, inforSearch, tagSuggestList) => {
    let data = {
        actionType: LogKibanaConstant.ACTION_TYPE.SEARCH,
        actionDetail: LogKibanaConstant.ACTION_DETAIL.SEARCH_KEY_WORD,
        keyword: ''
    };

    let tagSuggest = '';
    if (!Utils.isEmptyArray(tagSuggestList)) {
        let listTagSuggest = [...tagSuggestList].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            tagSuggest += listTagSuggest[i] + ' ';
        }
    }
    data.tag = tagSuggest.trim();

    if (!Utils.isEmptyArray(keywordList)) {
        data.keyword = [...keywordList].sort();
    }

    let keywordCondition = filterInput.optionSearch.methodSearch;
    if(keywordCondition === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        keywordCondition = Constant.SETTING_SEARCH_KEYWORD.K_NN;
    }

    data.sort = inforSearch.sortType;
    data.keywordCondition = keywordCondition;
    data.searchTarget = filterInput.optionSearch.attributeSearch === Constant.SETTING_SEARCH_KEYWORD.MUTIPLE ? LogKibanaConstant.SEARCH_TARGET.BODY : LogKibanaConstant.SEARCH_TARGET.CHAT;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    let isKnowLedge = searchContentType === LogKibanaConstant.CONTENT_TYPES_TICKET.KNOWLEDGE;
    let isPublicKnowledge = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC;
    let desCorp = filterInput.desCorp;
    let desProject = filterInput.desPrj;

    data.destinationOrgId = isKnowLedge && !isPublicKnowledge ? desCorp.id : filterInput.affiliationOrganization;
    data.destinationOrgDomain = isKnowLedge && !isPublicKnowledge ? desCorp.organizationDomain : corporationDetail.organizationDomain;
    data.destinationOrgName = isKnowLedge && !isPublicKnowledge ? desCorp.organizationName : corporationDetail.corporationName;
    data.destinationPrjId = isKnowLedge && !isPublicKnowledge ? desProject.id : filterInput.affiliationProject;
    data.destinationPrjName = isKnowLedge && !isPublicKnowledge ? desProject.name : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);

    data.orgActionId = corporationDetail.id;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId = projectInuseDetail.id;
    data.prjActionName =  Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.userActionId = userDetail.id;
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)?.trim();
    data.contentTypes = searchContentType;
    data.viewName = inforSearch.viewName;

    // data.hitNumber = Number(); // get on server
    data.operationScreen = operationScreen;
    if (isPublicKnowledge) {
        data.orgActionId = LogKibanaConstant.DUMMY_TEXT;
        data.orgActionDomain ='';
        data.orgActionName ='';
        data.prjActionId = LogKibanaConstant.DUMMY_TEXT;
        data.prjActionName = '';
        data.userActionId = LogKibanaConstant.DUMMY_TEXT;
        data.userActionEmail = '';
        data.userActionName = '' ;
        data.keywordCondition = ''
        data.searchTarget = ''
    }
    let logData = new FilterByKeySearchDto(data);
    return logData;
}

export const createKibanaTagSuggestData = (filterInput, tagSuggestList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, inforSearch, keywordList) => {
    let data = {
        actionType: LogKibanaConstant.ACTION_TYPE.SEARCH,
        actionDetail: LogKibanaConstant.ACTION_DETAIL.SEARCH_TAG_SUGGEST,
        keyword: ''
    };
    
    let tagSuggest = '';
    if (!Utils.isEmptyArray(tagSuggestList)) {
        let listTagSuggest = [...tagSuggestList].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            tagSuggest += listTagSuggest[i] + ' ';
        }
    }
    data.tag = tagSuggest.trim();

    if (!Utils.isEmptyArray(keywordList)) {
        data.keyword = [...keywordList].sort();
    }

    data.actionDate = new Date().toISOString();
    data.sessionId = getSession(); 
    data.destinationOrgId = filterInput.affiliationOrganization;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.corporationName;
    data.destinationPrjId = filterInput.affiliationProject;
    data.destinationPrjName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.orgActionId =operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : filterInput.affiliationOrganization;
    data.orgActionDomain = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : corporationDetail.organizationDomain;
    data.orgActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : corporationDetail.corporationName;
    data.prjActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : filterInput.affiliationProject;
    data.prjActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.userActionId =operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : userDetail.id;
    data.userActionEmail = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : userDetail.mail;
    data.userActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)?.trim();
    data.viewName = inforSearch.viewName;
    data.contentTypes = searchContentType;
    // data.hitNumber = Number(); // get on server
    data.operationScreen = operationScreen;
    let logData = new FilterByTagSuggestDto(data);
    return logData;
}

export const createKibanaDrillDownData = (filterInput, tagSuggestList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, inforSearch, keywordList) => {
    let data = {
        actionType: LogKibanaConstant.ACTION_TYPE.SEARCH,
        actionDetail: LogKibanaConstant.ACTION_DETAIL.SEARCH_DRILL_DOWN,
        dateType: '',
        keyword: ''
    };

    if (!Utils.isEmptyArray(keywordList)) {
        let keyword = [...keywordList].sort();
        data.keyword = keyword;
    }

    if (inforSearch?.searchDateType) {
        data.dateType =
            inforSearch.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
                ? LogKibanaConstant.DATE_TYPE.ON
                : LogKibanaConstant.DATE_TYPE.OFF;
    }

    if (data.dateType === LogKibanaConstant.DATE_TYPE.ON) {
        data.dateFrom =  '';
        data.dateTo = '';
    } else {
        data.dateFrom = inforSearch.fromSearchDate ? inforSearch.fromSearchDate.replaceAll('/', '-')+'T00:00:00.000Z' : '';
        data.dateTo = inforSearch.toSearchDate ? inforSearch.toSearchDate.replaceAll('/', '-')+'T00:00:00.000Z' : '';
    }
    data.dateTerm = inforSearch.searchDateAgoValue || inforSearch.searchDateAgoValue === 0 ? inforSearch.searchDateAgoValue : '';
    data.dateUnit = inforSearch.searchDateAgoUnit;
    let listOrTag = ''
    for (let i = 0; i < inforSearch.searchContainAny.length; i++) {
        listOrTag+=inforSearch.searchContainAny[i]+' ';
    }
    data.orTag = listOrTag.trim();
    let listExceptTag = ''
    for (let i = 0; i < inforSearch.searchNotInclude.length; i++) {
        listExceptTag+=inforSearch.searchNotInclude[i]+' ';
    }
    data.exceptTag = listExceptTag;
    let tagSuggest = '';
    if (!Utils.isEmptyArray(tagSuggestList)) {
        let listTagSuggest = [...tagSuggestList].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            tagSuggest += listTagSuggest[i] + ' ';
        }
    }

    data.tag = tagSuggest.trim();
    data.sort = inforSearch.sortType;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession(); 
    data.destinationOrgId = filterInput.affiliationOrganization;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.corporationName;
    data.destinationPrjId = filterInput.affiliationProject;
    data.destinationPrjName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.orgActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : filterInput.affiliationOrganization;
    data.orgActionDomain = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : corporationDetail.organizationDomain;
    data.orgActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : corporationDetail.corporationName;
    data.prjActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : filterInput.affiliationProject;
    data.prjActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.userActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : userDetail.id;
    data.userActionEmail = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : userDetail.mail;
    data.userActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)?.trim();
    data.contentTypes = searchContentType;
    // data.hitNumber = Number(); // get on server
    data.operationScreen = operationScreen;
    data.viewName = inforSearch.viewName;

    if(operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC){
        data.sort = ''
    }

    let logData = new FilterByDrillDownDto(data);
    return logData;
}

export const createKibanaViewChangeData = (filterInput, tagSuggestList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, inforSearch, keywordList) => {
    let viewKeywordCondition = inforSearch.viewKeywordCondition;
    let data = {
        actionType: LogKibanaConstant.ACTION_TYPE.SEARCH,
        actionDetail: LogKibanaConstant.ACTION_DETAIL.SEARCH_VIEW_CHANGE,
        keyword: ''
    };

    if(viewKeywordCondition === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        viewKeywordCondition = Constant.SETTING_SEARCH_KEYWORD.K_NN;
    }

    let tagSuggest = '';
    if (!Utils.isEmptyArray(tagSuggestList)) {
        let listTagSuggest = [...tagSuggestList].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            tagSuggest += listTagSuggest[i] + ' ';
        }
    }
    data.tag = tagSuggest.trim();

    if (!Utils.isEmptyArray(keywordList)) {
        let keyword = [...keywordList].sort();
        data.keyword = keyword;
    }

    data.viewId = inforSearch.viewId
    data.viewName = inforSearch.viewName;
    data.viewKeyword = inforSearch.viewKeyword;
    data.viewKeywordCondition = viewKeywordCondition;
    data.viewSearchTarget = inforSearch.viewSearchTarget;
    data.viewDateTerm = inforSearch.viewDateTerm;
    data.viewDateUnit = inforSearch.viewDateUnit;
    data.viewOrTag = inforSearch.viewOrTag;
    data.viewExceptTag = inforSearch.viewExceptTag;
    data.viewTag = inforSearch.viewTag;

    data.viewSort = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' :  inforSearch.viewSort;

    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    data.destinationOrgId = filterInput.affiliationOrganization;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.corporationName;
    data.destinationPrjId = filterInput.affiliationProject;
    data.destinationPrjName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.orgActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : filterInput.affiliationOrganization;
    data.orgActionDomain = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : corporationDetail.organizationDomain;
    data.orgActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : corporationDetail.corporationName;
    data.prjActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : filterInput.affiliationProject;
    data.prjActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.userActionId = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? LogKibanaConstant.DUMMY_TEXT : userDetail.id;
    data.userActionEmail = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : userDetail.mail;
    data.userActionName = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC ? '' : Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)?.trim();
    data.contentTypes = searchContentType;
    // data.hitNumber = Number(); // get on server
    data.operationScreen = operationScreen;
    if (inforSearch.viewDateType) {
        data.viewDateType = inforSearch.viewDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO ? LogKibanaConstant.DATE_TYPE.ON : LogKibanaConstant.DATE_TYPE.OFF;
        if (data.viewDateType === LogKibanaConstant.DATE_TYPE.ON) {
            data.viewDateFrom = '';
            data.viewDateTo = '';
        } else {
            data.viewDateFrom = inforSearch.viewDateFrom ? inforSearch.viewDateFrom.replaceAll('/', '-')+'T00:00:00.000Z' : '';
            data.viewDateTo = inforSearch.viewDateTo ? inforSearch.viewDateTo.replaceAll('/', '-')+'T00:00:00.000Z' : '';
        }
    } else {
        data.viewDateType = '';
        data.viewDateFrom = '';
        data.viewDateTo = '';
    }

    let logData = new FilterByViewChangeDto(data);
    return logData;
}

const createKibanaRemoveTag = (filterInput, keywordList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, tagSuggestList, inforSearch, removeItem) => {
    let data = {
        actionType: LogKibanaConstant.ACTION_TYPE.SEARCH,
        actionDetail: LogKibanaConstant.ACTION_DETAIL.SEARCH_TAG_REMOVE,
        keyword: ''
    };

    if (!Utils.isEmptyArray(keywordList)) {
        data.keyword = [...keywordList].sort();
    }

    let keywordCondition = filterInput.optionSearch.methodSearch;

    if(keywordCondition === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        keywordCondition = Constant.SETTING_SEARCH_KEYWORD.K_NN;
    }
    data.keywordCondition = keywordCondition;
    data.searchTarget = filterInput.optionSearch.attributeSearch === Constant.SETTING_SEARCH_KEYWORD.MUTIPLE ? LogKibanaConstant.SEARCH_TARGET.BODY : LogKibanaConstant.SEARCH_TARGET.CHAT;
    let dateType = '';
    if (inforSearch.searchDateType) {
        dateType = inforSearch.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO ? LogKibanaConstant.DATE_TYPE.ON : LogKibanaConstant.DATE_TYPE.OFF;
    }
    data.dateType = dateType;
    if (data.dateType === LogKibanaConstant.DATE_TYPE.ON) {
        data.dateFrom = ''
        data.dateTo = ''
    } else {
        data.dateFrom = inforSearch.fromSearchDate ? inforSearch.fromSearchDate.replaceAll('/', '-')+'T00:00:00.000Z' : '';
        data.dateTo = inforSearch.toSearchDate ? inforSearch.toSearchDate.replaceAll('/', '-')+'T00:00:00.000Z' : '';
    }

    data.dateTerm = inforSearch.searchDateAgoValue || inforSearch.searchDateAgoValue === 0 ? inforSearch.searchDateAgoValue : '';
    data.dateUnit = inforSearch.searchDateAgoUnit;
    let listOrTag = ''
    for (let i = 0; i < inforSearch.searchContainAny.length; i++) {
        listOrTag+=inforSearch.searchContainAny[i]+' ';
    }
    data.orTag = listOrTag.trim();
    let listExceptTag = ''
    for (let i = 0; i < inforSearch.searchNotInclude.length; i++) {
        listExceptTag+=inforSearch.searchNotInclude[i]+' ';
    }
    data.exceptTag = listExceptTag;
    let tagSuggest = '';
    let tagRemove = `${removeItem?.tagName}@${removeItem?.fieldName}`
    if (!Utils.isEmptyArray(tagSuggestList)) {
        let listTagSuggest = [...tagSuggestList].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            if (tagRemove !== listTagSuggest[i]) {
                tagSuggest += listTagSuggest[i] + ' ';
            }
        }
    }
    data.tag = tagSuggest.trim();
    data.sort = inforSearch.sortType;
    data.removeTag = tagRemove; 
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession(); 
    let isKnowLedge = searchContentType === LogKibanaConstant.CONTENT_TYPES_TICKET.KNOWLEDGE;
    let isPublicKnowledge = operationScreen === LogKibanaConstant.OPERATION_SCREEN.PUBLIC;
    let desCorp = filterInput.desCorp;
    let desProject = filterInput.desPrj;
    data.destinationOrgId = isKnowLedge && !isPublicKnowledge ? desCorp.id : filterInput.affiliationOrganization;
    data.destinationOrgDomain = isKnowLedge && !isPublicKnowledge ? desCorp.organizationDomain : corporationDetail.organizationDomain;
    data.destinationOrgName = isKnowLedge && !isPublicKnowledge ? desCorp.organizationName : corporationDetail.corporationName;
    data.destinationPrjId = isKnowLedge && !isPublicKnowledge ? desProject.id : filterInput.affiliationProject;
    data.destinationPrjName = isKnowLedge && !isPublicKnowledge ? desProject.name : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);

    data.orgActionId = corporationDetail.id;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId = projectInuseDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.userActionId = userDetail.id;
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)?.trim();
    data.contentTypes = searchContentType;
    // data.hitNumber = Number(); // get on server
    data.operationScreen = operationScreen;
    data.viewName = inforSearch.viewName;

    if (isPublicKnowledge) {
        data.orgActionId = LogKibanaConstant.DUMMY_TEXT;
        data.orgActionDomain = '';
        data.orgActionName = '';
        data.prjActionId = LogKibanaConstant.DUMMY_TEXT;
        data.prjActionName = '';
        data.userActionId = LogKibanaConstant.DUMMY_TEXT;
        data.userActionEmail = '';
        data.userActionName = '';
        data.keywordCondition = ''
        data.searchTarget = ''
        data.sort = ''
    }

    let logData = new FilterByTagRemoveDto(data);

    return logData;
}

export const createKibanaPublicKnowledgeRobotChat = (
    selectedOption,
    affiliationOrganization,
    affiliationProject,
    corporationDetail,
    projectInuseDetail,
    content,
    categoryIdSelected
) => {
    if (Utils.isEmptyObject(selectedOption)) return;

    switch (content.messageType) {
        case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY:
            return createKibanaCategorySelect(
                selectedOption,
                affiliationOrganization,
                affiliationProject,
                corporationDetail,
                projectInuseDetail
            );
        case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_FIELD:
            return createKibanaSelectField(
                selectedOption,
                affiliationOrganization,
                affiliationProject,
                corporationDetail,
                projectInuseDetail,
                content,
                categoryIdSelected
            );
        case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM:
            return createKibanaSelectTag(
                selectedOption,
                affiliationOrganization,
                affiliationProject,
                corporationDetail,
                projectInuseDetail,
                content,
                categoryIdSelected
            );

        default:
            break;
    }
};

const createKibanaCategorySelect = (
    category,
    affiliationOrganization,
    affiliationProject,
    corporationDetail,
    projectInuseDetail
) => {

    let data = {};
    data.actionType = LogKibanaConstant.ACTION_TYPE.KNOWLEDGE_ROBO;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.CATEGORY_SELECT;
    data.qaCategory = category.name;
    data.tagGroup = null;
    data.selectTag = null;
    data.searchCondition = category.name || null;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    data.destinationOrgId = corporationDetail.id;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.name;
    data.destinationPrjId = projectInuseDetail.id;
    data.destinationPrjName = projectInuseDetail.name;
    data.orgActionId = LogKibanaConstant.DUMMY_TEXT;
    data.orgActionDomain = '';
    data.orgActionName = '';
    data.prjActionId = LogKibanaConstant.DUMMY_TEXT;
    data.prjActionName = '';
    data.userActionId = LogKibanaConstant.DUMMY_TEXT;
    data.userActionEmail = '';
    data.userActionName = '';
    data.operationScreen = LogKibanaConstant.OPERATION_SCREEN.PUBLIC;

    let logData = new FilterByCategorySelectDto(data);
    
    return logData;
};

const createKibanaSelectField = (
    selectedField,
    affiliationOrganization,
    affiliationProject,
    corporationDetail,
    projectInuseDetail,
    content,
    categoryIdSelected
) => {
    let data = {};

    data.actionType = LogKibanaConstant.ACTION_TYPE.KNOWLEDGE_ROBO;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.TAG_GROUP_SELECT;
    data.qaCategory = content.categoryName || '';
    data.tagGroup = selectedField.name;
    data.selectTag = null;
    data.searchCondition = content.categoryName || null;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    data.destinationOrgId = corporationDetail.id;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.name;
    data.destinationPrjId = projectInuseDetail.id;
    data.destinationPrjName = projectInuseDetail.name;
    data.orgActionId = LogKibanaConstant.DUMMY_TEXT;
    data.orgActionDomain = '';
    data.orgActionName = '';
    data.prjActionId = LogKibanaConstant.DUMMY_TEXT;
    data.prjActionName = '';
    data.userActionId = LogKibanaConstant.DUMMY_TEXT;
    data.userActionEmail = '';
    data.userActionName = '';
    data.operationScreen = LogKibanaConstant.OPERATION_SCREEN.PUBLIC;

    let logData = new KnowledgeRoboSelectTagGroupDto(data);

    return logData;
};

const createKibanaSelectTag = (
    selectedTag,
    affiliationOrganization,
    affiliationProject,
    corporationDetail,
    projectInuseDetail,
    content,
    categoryIdSelected
) => {
    let data = {};

    data.actionType = LogKibanaConstant.ACTION_TYPE.KNOWLEDGE_ROBO;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.TAG_SELECT;
    data.qaCategory = content.nameCategory || '';
    data.tagGroup = content.nameOfTagField || '';
    data.selectTag = content.accumulatedSelectTag || '';
    data.searchCondition = [content.nameCategory, content.accumulatedSelectTag].filter(s => s).join(' ') || null;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    data.destinationOrgId = corporationDetail.id;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.name;
    data.destinationPrjId = projectInuseDetail.id;
    data.destinationPrjName = projectInuseDetail.name;
    data.orgActionId = LogKibanaConstant.DUMMY_TEXT;
    data.orgActionDomain = '';
    data.orgActionName = '';
    data.prjActionId = LogKibanaConstant.DUMMY_TEXT;
    data.prjActionName = '';
    data.userActionId = LogKibanaConstant.DUMMY_TEXT;
    data.userActionEmail = '';
    data.userActionName = '';
    data.operationScreen = LogKibanaConstant.OPERATION_SCREEN.PUBLIC;

    let logData = new KnowledgeRoboSelectTagDto(data);
    return logData;
};

export const createKibanaSelectKnowledgeTicket = ( API, projectInuseDetail, currentCorporationDetail, ticketId, filterState = {} ) => {
    const { qaCategory = null, tagGroup = null, selectTag = null } = filterState;
    const searchCondition = [qaCategory, selectTag].filter(s => s).join(' ') || null;

    let logData = {
        actionType : LogKibanaConstant.ACTION_TYPE.KNOWLEDGE_ROBO,
        actionDetail : LogKibanaConstant.ACTION_DETAIL.CLICK_KNOWLEDGE,
        actionDate : new Date().toISOString(),
        sessionId : getSession(),
        qaCategory : qaCategory,
        tagGroup : tagGroup,
        selectTag : selectTag,
        searchCondition : searchCondition,
        destinationOrgId : currentCorporationDetail.id,
        destinationOrgDomain : currentCorporationDetail.organizationDomain,
        destinationOrgName : currentCorporationDetail.name,
        destinationPrjId : projectInuseDetail.id,
        destinationPrjName : projectInuseDetail.name,
        orgActionId : LogKibanaConstant.DUMMY_TEXT,
        orgActionDomain : '',
        orgActionName : '',
        prjActionId : LogKibanaConstant.DUMMY_TEXT,
        prjActionName : '',
        userActionId : LogKibanaConstant.DUMMY_TEXT,
        userActionEmail : '',
        userActionName : '',
        operationScreen : LogKibanaConstant.OPERATION_SCREEN.PUBLIC,
        ticketId: ticketId
    }

    logData = new KnowledgeRoboClickKnowledgeDto(logData);
    let params = {
        logType: LogKibanaConstant.KNOWLEDGE_ROBO.CLICK_KNOWLEDGE,
        logKibanaData: logData
    };
    createKibanaLogAPI(API, params);
}

export const createKibanaDataContentOperation = (
    lastUserAction,
    dataLog,
    operationScreen
) => {
    if (!lastUserAction) {
        return;
    }
    switch (lastUserAction) {
        case LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW:
            return createKibanaViewContentOperation(
                dataLog,
                operationScreen
            );
        // break;
        case LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD:
            return createKibanaAddContentOperation(
                dataLog
            );
        case LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT:
            return createKibanaEditContentOperation(
                dataLog
            );
        default:
            break;
    }
};

const getElapsedTime = (startTime, endTime) => {
    let ms = new Date(endTime) - new Date(startTime);
    ms = Math.abs(ms)
    // Convert to seconds:
    let seconds = ms / 1000;
    // Extract hours:
    const hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // Extract minutes:
    const minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
    // Keep only seconds not extracted to minutes:
    seconds = parseInt(seconds % 60);
    let res = hours + ':' + minutes + ':' + seconds;
    return res;
};

const getValuePublicRange = (view) => {
    if (!view || Utils.isEmptyArray(view)) return view;

    let publicRange = `${Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.CREATOR},${Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_PROJECT},`
    let isExistRoleInOrg = view.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG);
    let isExistRoleB2BCustomer = view.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER);
    let isExistRoleB2BSupport = view.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT);
    let isExistRolePublic = view.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC);

    publicRange = isExistRoleInOrg ? publicRange += Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_ORG + ',' : publicRange;
    publicRange = isExistRoleB2BCustomer ? publicRange += Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.B2B_CUSTOMER + ',' : publicRange;
    publicRange = isExistRoleB2BSupport ? publicRange += Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.B2B_SUPPORT + ',' : publicRange;
    publicRange = isExistRolePublic ? publicRange += Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.PUBLIC + ',' : publicRange;
    
    publicRange = publicRange.substring(0, publicRange.length - 1);
    return publicRange;
}

const isTicketQA = (ticketType) => {
    if ([Constant.TICKET_TYPE.QA, Constant.TICKET_TYPE.INTERNAL_QA, Constant.TICKET_TYPE.EXTERNAL_QA, Constant.TICKET_TYPE.ESCALATION, Constant.TICKET_TYPE.DELEGATE].includes(ticketType)) {
        return true;
    }
    return false;
}

export const formatViewTicketTaskLogKibana = (dataLog) => {
    let newDataLog = {};
    newDataLog.actionType = dataLog.actionType
    newDataLog.actionDetail = dataLog.actionDetail
    newDataLog.actionDate = dataLog.actionDate
    newDataLog.sessionId = getSession(); 
    newDataLog.destinationOrgId = dataLog.destinationOrgId
    newDataLog.destinationOrgDomain =  dataLog.destinationOrgDomain
    newDataLog.destinationOrgName = dataLog.destinationOrgName
    newDataLog.destinationPrjId = dataLog.destinationPrjId
    newDataLog.destinationPrjName = dataLog.destinationPrjName

    newDataLog.orgActionId = dataLog.orgActionId
    newDataLog.orgActionDomain = dataLog.orgActionDomain
    newDataLog.orgActionName = dataLog.orgActionName
    newDataLog.prjActionId = dataLog.prjActionId
    newDataLog.prjActionName = dataLog.prjActionName

    newDataLog.userActionId = dataLog.userActionId
    newDataLog.userActionEmail = dataLog.userActionEmail
    newDataLog.userActionName = dataLog.userActionName
    newDataLog.contentTypes = dataLog.contentTypes
    newDataLog.ticketId =  dataLog.ticketId
    newDataLog.ticketName =  dataLog.ticketName
    newDataLog.creatorId =  dataLog.creatorId
    newDataLog.creatorEmail =  dataLog.creatorEmail
    newDataLog.creatorName = dataLog.creatorName
    newDataLog.formatId =  dataLog.formatId
    newDataLog.formatName =  dataLog.formatName
    newDataLog.elapsedTime = dataLog.elapsedTime
    newDataLog.outline = dataLog.outline
    newDataLog.assigneeId = dataLog.assigneeId
    newDataLog.assigneeEmail = dataLog.assigneeEmail
    newDataLog.assigneeName = dataLog.assigneeName
    newDataLog.operationScreen = dataLog.operationScreen;
    newDataLog.viewBy = null
    return newDataLog
}

const createKibanaViewContentOperation = (dataLog, operationScreen) => {
    const {rootCorporationDetail, rootProjectDetail, corporationDetail, projectDetail, userDetail, ticketDetail, metaData} = dataLog;
    let data = {};

    data.actionType = LogKibanaConstant.ACTION_TYPE.CONTENT_OPERATION;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.CONTENT_OPERATION_VIEW;

    data.actionDate = new Date().toISOString();
    data.sessionId = getSession(); 

    data.destinationOrgId = rootCorporationDetail.id;
    data.destinationOrgDomain = rootCorporationDetail?.organizationDomain; //Get in server
    data.destinationOrgName = Utils.convertJSONDataToObject(rootCorporationDetail.name)?.jp?.text;
    data.destinationPrjId = rootProjectDetail.id;
    data.destinationPrjName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, rootProjectDetail.name);

    data.orgActionId = corporationDetail.affiliationOrganization;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId = projectDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail.name);

    data.userActionId = userDetail.id;
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail);

    data.contentTypes = getContentTypesTicket(metaData.ticketType);
    data.ticketId = ticketDetail.id;
    
    let outline = Utils.convertJSONDataToObject(ticketDetail.outline);
    data.ticketName = outline?.jp;
    data.creatorId = ticketDetail.creator;
    data.creatorEmail = ticketDetail?.creatorEmail; // Get in server
    data.creatorName = ticketDetail.createrUserName;
    data.formatId = metaData?.formDetailId; // Get in server
    data.formatName = ticketDetail.usingFormName; 

    if (ticketDetail?.parent) {
        let parentTicket = Utils.convertJSONDataToObject(ticketDetail.parentTicket);
        data.escalationTicketId = parentTicket.id;
        data.escalationTicketName = parentTicket.outline;
    }
    data.elapsedTime = getElapsedTime(ticketDetail.createdAt, data.actionDate);
    data.publicRange = getValuePublicRange(ticketDetail.viewPermission);
    data.outline = outline?.jp;
    if (ticketDetail.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) {
        data.ticketName = ticketDetail.usingFormName;
        data.outline = ticketDetail.usingFormName;
    }
    if (!data.outline) {
        data.outline = LogKibanaConstant.TICKET_NAME.NULL;
        data.ticketName = LogKibanaConstant.TICKET_NAME.NULL;
    }
    if (ticketDetail?.personInCharge) {
        let personInChargeInfo = ticketDetail?.personInChargeInfo;
        data.assigneeId = personInChargeInfo?.id;
        data.assigneeEmail = personInChargeInfo?.assigneeEmail; // Get in server
        data.assigneeName = personInChargeInfo?.fullName;
    };
    if ((isTicketQA(ticketDetail.ticketType) || ticketDetail.ticketType === Constant.TICKET_TYPE.TASK) && !data.assigneeId) {
        data.assigneeId = LogKibanaConstant.UNASSIGN;
    }

    if([Constant.TICKET_TYPE.KNOWLEDGE,Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(ticketDetail.ticketType)){
        data.viewBy = dataLog.viewBy === '検索' ? '検索' : '検索無'
    }else{
        data.viewBy = ''
    }

    data.operationScreen = operationScreen;

    let logData = new ContentOperationViewDto(data);
    return logData;

}

const getContentTypesTicket = (ticketType) => {
    if (!ticketType) return '';
    let contentType = '';
    switch (ticketType) {
        case Constant.TICKET_TYPE.QA:
        case Constant.TICKET_TYPE.INTERNAL_QA:
        case Constant.TICKET_TYPE.EXTERNAL_QA:
        case Constant.TICKET_TYPE.ESCALATION:
            contentType = LogKibanaConstant.CONTENT_TYPE.QA;
            break;
        case Constant.TICKET_TYPE.TASK:
            contentType = LogKibanaConstant.CONTENT_TYPE.TASK;
            break;
        case Constant.TICKET_TYPE.BROADCAST_CHILD:
        case Constant.TICKET_TYPE.BROADCAST_PARENT:
        case Constant.TICKET_TYPE.NOTICE:
            contentType = LogKibanaConstant.CONTENT_TYPE.NOTICE
            break;
        case Constant.TICKET_TYPE.KNOWLEDGE:
        case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
        case Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE:
        case Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE:
            contentType = LogKibanaConstant.CONTENT_TYPE.KNOWLEDGE
            break;
        case Constant.TICKET_TYPE.TELEPHONE:
            contentType = LogKibanaConstant.CONTENT_TYPE.VOICE
            break;
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK:
            contentType = LogKibanaConstant.CONTENT_TYPE.B2B_PARTNER_EXTERNAL
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
            contentType = LogKibanaConstant.CONTENT_TYPE.B2B_PARTNER_INTERNAL
            break;
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER:
            contentType = LogKibanaConstant.CONTENT_TYPE.B2B_SUPPORT_EXTERNAL
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER:
        case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
            contentType = LogKibanaConstant.CONTENT_TYPE.B2B_SUPPORT_INTERNAL
            break;
        case Constant.TICKET_TYPE.EMAIL:
        case Constant.TICKET_TYPE.EMAIL_REPLY:
            contentType = LogKibanaConstant.CONTENT_TYPE.EMAIL;
            break;
        default:
            contentType = LogKibanaConstant.CONTENT_TYPE.QA;
            break;
    }
    return contentType;
};

const getValueAdditionalViewPermissions = (view) => {
    if (!view || Utils.isEmptyArray(view)) return '';
    let value = ''
    for (let i = 0; i < view.length; i++) {
        const element = view[i];
        value += Utils.convertJSONDataToObject(element.name)?.jp?.text + ',';
    }

    value = value.substring(0, value.length - 1);
    return value;
}

const createKibanaAddContentOperation = (dataLog, operationScreen) => {
    const {rootCorporationDetail, rootProjectDetail, corporationDetail, projectDetail, userDetail, ticketDetail, metaData} = dataLog;
    let data = {};

    data.actionType = LogKibanaConstant.ACTION_TYPE.CONTENT_OPERATION;
    let actionDetail = LogKibanaConstant.ACTION_DETAIL.CONTENT_OPERATION_CREATE;
    if (dataLog.isCreateKnowledge) {
        actionDetail = dataLog.isCreateCSV ? LogKibanaConstant.ACTION_DETAIL.CONTENT_OPERATION_CREATE_CSV : LogKibanaConstant.ACTION_DETAIL.CONTENT_OPERATION_CREATE_MANUAL;
    }
    data.actionDetail = actionDetail;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();

    data.qaCategory = dataLog.qaCategory;   
    data.ticketCreationScreen = dataLog.ticketCreationScreen;
    data.destinationOrgId = rootCorporationDetail.id;
    data.destinationOrgDomain = rootCorporationDetail?.organizationDomain; //Get in server
    data.destinationOrgName = Utils.convertJSONDataToObject(rootCorporationDetail.name)?.jp?.text;
    data.destinationPrjId = rootProjectDetail.id;
    data.destinationPrjName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, rootProjectDetail.name);

    data.orgActionId = corporationDetail.affiliationOrganization;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId = projectDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail.name);

    data.userActionId = userDetail?.id; // Get in server
    data.userActionEmail = userDetail?.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail); // Get in server

    data.contentTypes = getContentTypesTicket(metaData.ticketType);
    data.ticketId = ticketDetail.id;
    
    let outline = Utils.convertJSONDataToObject(ticketDetail.outline);
    data.ticketName = outline?.jp;
    data.creatorId = ticketDetail.creator;
    data.creatorEmail = ticketDetail?.creatorEmail; // Get in server
    data.creatorName = ticketDetail?.createrUserName; //Get in server
    data.formatId = metaData?.formDetailId; // Get in server
    data.formatName = ticketDetail.usingFormName; 

    if (ticketDetail?.isEscalation) {
        let parentTicket = ticketDetail.parent;
        data.escalationTicketId = parentTicket.id;
        data.escalationTicketName = Utils.convertJSONDataToObject(parentTicket.outline)?.jp;
    }
    data.elapsedTime = getElapsedTime(ticketDetail.createdAt, data.actionDate);
    let publicRange = getValuePublicRange(metaData.viewPermissions);
    if (metaData.additionalViewPermissions && !Utils.isEmptyArray(metaData.additionalViewPermissions)) {
        publicRange += ',' + getValueAdditionalViewPermissions(metaData.additionalViewPermissions);
    }
    if (![Constant.TICKET_TYPE.TASK].includes(metaData.ticketType)) {
        data.publicRange = publicRange;
    }
    data.outline = outline?.jp;
    if (ticketDetail.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) {
        data.ticketName = ticketDetail.usingFormName;
        data.outline = ticketDetail.usingFormName;
    }
    if (!data.outline) {
        data.outline = LogKibanaConstant.TICKET_NAME.NULL;
        data.ticketName = LogKibanaConstant.TICKET_NAME.NULL;
    }
    if ([Constant.TICKET_TYPE.QA, Constant.TICKET_TYPE.TASK].includes(metaData.ticketType)) {
        data.assigneeId = LogKibanaConstant.UNASSIGN;
        if (ticketDetail?.personInCharge) {
            let personInChargeInfo = ticketDetail.personInChargeInfo;
            data.assigneeId = personInChargeInfo.id;
            data.assigneeEmail = personInChargeInfo.assigneeEmail; // Get in server
            data.assigneeName = personInChargeInfo.fullName;
        }
    }

    data.logType = LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT
    

    let logData = new ContentOperationCreateDto(data);
    return logData;
}

export const createKibanaEditContentOperation = (dataLog) => {
    let data = {};
    const {corporationDetail, projectDetail, userDetail, ticketDetail, formDetail,publicRange} = dataLog;

    data.actionType = LogKibanaConstant.ACTION_TYPE.CONTENT_OPERATION;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();

    data.orgActionId = corporationDetail.affiliationOrganization;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId = projectDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail.name);
    data.contentTypes = getContentTypesTicket(ticketDetail.ticketType);
    data.userActionId = userDetail.id; // Get in server
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail); // Get in server
    data.ticketId = ticketDetail.id

    let outline = ticketDetail.outline;
    data.ticketName = outline;
    data.creatorId = ticketDetail.creator;
    data.creatorEmail = ticketDetail?.creatorEmail; // Get in server
    data.creatorName = ticketDetail?.createrUserName; //Get in server
    data.formatId = formDetail?.id; // Get in server
    data.formatName = ticketDetail.usingFormName;
    
    if (ticketDetail.ticketType === Constant.TICKET_TYPE.ESCALATION) {
        let parentTicket = ticketDetail.parent;
        data.escalationTicketId = parentTicket.id;
        data.escalationTicketName = Utils.convertJSONDataToObject(parentTicket.outline)?.jp;
    }else{
        data.escalationTicketId = ''
        data.escalationTicketName = ''
    }
    //data.userDefinedFields = ''
    data.elapsedTime = getElapsedTime(ticketDetail.createdAt, data.actionDate);
    data.publicRange = !Utils.isEmptyString(publicRange) ? publicRange : ''
    data.outline = outline?.jp;

    if (ticketDetail.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) {
        data.ticketName = ticketDetail.usingFormName;
        data.outline = ticketDetail.usingFormName;
    }
    data.assigneeId = '';
    data.assigneeEmail = ''; // Get in server
    data.assigneeName ='';
    if ([Constant.TICKET_TYPE.QA, Constant.TICKET_TYPE.TASK].includes(ticketDetail.ticketType)) {
        data.assigneeId = LogKibanaConstant.UNASSIGN;
        if (ticketDetail?.personInCharge) {
            let personInChargeInfo = ticketDetail.personInChargeInfo;
            data.assigneeId = personInChargeInfo.id ? personInChargeInfo.id : '';
            data.assigneeEmail = personInChargeInfo.assigneeEmail ? personInChargeInfo.assigneeEmail : ''; // Get in server
            data.assigneeName = personInChargeInfo.fullName ?personInChargeInfo.fullName : '';
        }
    }

    if ([Constant.TICKET_TYPE.TASK].includes(ticketDetail.ticketType)) {
        delete data.publicRange;
    }

    return data

}


export const createKibanaEditContentOperationFormList = (dataLog) => {
    let data = {};
    const {corporationDetail, projectDetail, userDetail, ticketDetail,publicRange} = dataLog;

    data.actionType = LogKibanaConstant.ACTION_TYPE.CONTENT_OPERATION;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();

    data.orgActionId = corporationDetail.affiliationOrganization;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId = projectDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail.name);
    data.contentTypes = getContentTypesTicket(ticketDetail.ticketType);
    data.userActionId = userDetail?.id; // Get in server
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail); // Get in server
    data.ticketId = ticketDetail.id
    
    //data.userDefinedFields = ''
    data.elapsedTime = getElapsedTime(ticketDetail.createdAt, data.actionDate);
    if (![Constant.TICKET_TYPE.TASK].includes(ticketDetail.ticketType)) {
        data.publicRange = !Utils.isEmptyString(publicRange) ? publicRange : ''
    }

    return data

}

const generateSessionChat = ticketInfo => {
    // typeof guard: this emitter sits on the call critical path, so a malformed id must degrade to
    // an empty sessionId rather than throw.
    if (typeof ticketInfo?.id !== 'string' || Utils.isEmptyString(ticketInfo?.id)) return '';

    const match = ticketInfo?.id.match(UUID_PATTERN);
    if (!match) return '';

    if (ticketInfo?.ticketType === Constant.TICKET_TYPE.TELEPHONE)
        return `${LogKibanaConstant.CHAT.TELEPHONE.SESSION_PREFIX}${match[0]}`;

    return getSession();
};

export const createKibanaDataChat = (
    selectThread,  
    API,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    ticketInfo
) => {
    if (Utils.isEmptyObject(selectThread) || Utils.isEmptyObject(corporationDetail) || Utils.isEmptyObject(projectInuseDetail) || Utils.isEmptyObject(userDetail) || Utils.isEmptyObject(ticketInfo)) return;

    const threadType = selectThread.threadType;
    let data = {};

    data.actionType = LogKibanaConstant.ACTION_TYPE.CHAT;
    data.actionDate = new Date().toISOString();
    data.sessionId = generateSessionChat(ticketInfo);
    data.destinationOrgId = "";       // get on server
    data.destinationOrgDomain = "";   // get on server
    data.destinationOrgName = "";     // get on server
    data.destinationPrjId = "";       // get on server
    data.destinationPrjName = "";     // get on server

    data.orgActionId = corporationDetail.id;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corporationDetail.name);

    data.prjActionId = projectInuseDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);

    data.userActionId = userDetail.id;
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail);

    data.contentTypes = getContentTypesTicket(ticketInfo.ticketType);
    data.ticketId = ticketInfo.id;

    data.ticketName = '';           // get on server
    data.creatorId = '';            // get on server
    data.creatorEmail = '';         // get on server
    data.creatorName = '';          // get on server
    data.formatId = '';             // get on server
    data.formatName = '';           // get on server

    let logData = {};
    let params = {};
    switch (threadType) {
        case Constant.THREAD_TYPE.CUSTOMER:
            data.actionDetail = LogKibanaConstant.CHAT_ACTION_LOCATION.CUSTOMER;

            logData = new ChatOnCustomerDto(data);
            
            params.logType = LogKibanaConstant.CHAT_ACTION_LOCATION.CUSTOMER;
            params.logKibanaData = logData;
            params.ticketInfo = ticketInfo;
            createKibanaLogAPI(API, params);
            break;
        case Constant.THREAD_TYPE.INTERNAL:
            data.actionDetail = LogKibanaConstant.CHAT_ACTION_LOCATION.PROJECT;

            logData = new ChatOnProjectDto(data);
            
            params.logType = LogKibanaConstant.CHAT_ACTION_LOCATION.PROJECT;
            params.logKibanaData = logData;
            params.ticketInfo = ticketInfo;
            createKibanaLogAPI(API, params);
            break;
        case Constant.THREAD_TYPE.ESCALATION:
            data.actionDetail = selectThread.projectName === trI18n('USER07BTN006') ? LogKibanaConstant.CHAT_ACTION_LOCATION.CUSTOMER : LogKibanaConstant.CHAT_ACTION_LOCATION.ESCALATION;

            logData = new ChatOnEscalationDto(data);
            
            params.logType = LogKibanaConstant.CHAT_ACTION_LOCATION.ESCALATION;
            params.logKibanaData = logData;
            params.ticketInfo = ticketInfo;
            createKibanaLogAPI(API, params);
            break;
        case Constant.THREAD_TYPE.DELEGATE:
            data.actionDetail = LogKibanaConstant.CHAT_ACTION_LOCATION.KNOWLEDGE;

            logData = new ChatOnKnowledgeDto(data);
            
            params.logType = LogKibanaConstant.CHAT_ACTION_LOCATION.KNOWLEDGE;
            params.logKibanaData = logData;
            params.ticketInfo = ticketInfo;
            createKibanaLogAPI(API, params);
            break;
        default:
            break;
    }
};

export const createKibanaInteractChatAI = (dataLog, screen = LogKibanaConstant.AI_CHAT_SCREEN.AI) => {
    const {
        rootCorporationDetailId,
        rootProjectDetail,
        corporationDetail,
        projectDetail,
        userDetail,
        userSelectedPrompt,
        projectIdKnowledgeSelected,
        viewName,
        searchTagSuggestKnowledge,
        keyword,
        isTurnOnToggleUsingKnowledgeTicketList,
        //using for pks
        qaCategoryId,
        tagFieldsSelected
    } = dataLog;

    let data = {};
    let viewNameOfChatAI = viewName
    data.actionType = LogKibanaConstant.ACTION_TYPE.AI_CHAT;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.INTERACT_WITH_AI;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();

    //get in server
    data.destinationOrgId = rootCorporationDetailId;
    data.destinationOrgDomain = '';
    data.destinationOrgName = '';

    if(projectIdKnowledgeSelected === LogKibanaConstant.ALL_KNOWLEDGE_IN_ORG.KEY) {
        data.destinationPrjId = '';
        data.destinationPrjName = LogKibanaConstant.ALL_KNOWLEDGE_IN_ORG.VALUE;
        viewNameOfChatAI = null;
        data.userSelectedPromptID = '';
        data.userSelectedPromptName = '';
        data.basicPromptID = '';
        data.basicPromptName = '';
    } else {
        data.destinationPrjId = rootProjectDetail.id;
        data.destinationPrjName = (screen == LogKibanaConstant.AI_CHAT_SCREEN.AI) ? Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            rootProjectDetail.name
        ) :  rootProjectDetail?.name

        let listUserSelectedPromptID = [];
        let lisUserSelectedPromptName = [];
    
        if(!Utils.isEmptyArray(userSelectedPrompt)) {
            userSelectedPrompt.forEach(item => {
                listUserSelectedPromptID.push(item.id);
                lisUserSelectedPromptName.push(item.title);
            })
        }
    
        data.userSelectedPromptID =
            Utils.isEmptyArray(listUserSelectedPromptID) ||
            screen == LogKibanaConstant.AI_CHAT_SCREEN.ROBO
                ? null
                : listUserSelectedPromptID.join('、');
        data.userSelectedPromptName =
            Utils.isEmptyArray(lisUserSelectedPromptName) ||
            screen == LogKibanaConstant.AI_CHAT_SCREEN.ROBO
                ? null
                : lisUserSelectedPromptName.join('、');
    
        data.basicPromptID = dataLog?.basicPromptID ? dataLog.basicPromptID: null;
        data.basicPromptName = dataLog.basicPromptName ? dataLog.basicPromptName: null;
    }
    // it's dummy text if you in pks
    data.orgActionId = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI
        ? corporationDetail?.affiliationOrganization
        : LogKibanaConstant.DUMMY_TEXT;
    data.orgActionDomain = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI
        ? corporationDetail?.organizationDomain
        : LogKibanaConstant.DUMMY_TEXT;
    data.orgActionName = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI
        ? corporationDetail?.corporationName
        : LogKibanaConstant.DUMMY_TEXT;

    data.prjActionId = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI
        ? projectDetail?.id
        : LogKibanaConstant.DUMMY_TEXT;
    data.prjActionName = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI
        ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail?.name)
        : LogKibanaConstant.DUMMY_TEXT;

    data.userActionId = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI ? userDetail.id : LogKibanaConstant.DUMMY_TEXT;
    data.userActionEmail = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI ? userDetail.mail : LogKibanaConstant.DUMMY_TEXT;
    data.userActionName = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI
        ? Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)
        : LogKibanaConstant.DUMMY_TEXT;
    //data.hitNumber = null
    data.aiChatScreen = screen;
    data.aiTabChatName = screen == LogKibanaConstant.AI_CHAT_SCREEN.AI ? dataLog?.tabNameChatAI : null;
    data.aiChatInquiryText = dataLog?.aiChatInquiryText;

    //out of scope
    // data.knowIDRefInAiChatInquiry = "";

    //will fill data server.
    data.aiChatAnswerText = '';

    let tagSuggest = '';
    if (!Utils.isEmptyArray(searchTagSuggestKnowledge)) {
        let listTagSuggest = [...searchTagSuggestKnowledge].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            tagSuggest += listTagSuggest[i] + ' ';
        }
    }
    const valuesOfSearchCondition = (screen == LogKibanaConstant.AI_CHAT_SCREEN.AI && isTurnOnToggleUsingKnowledgeTicketList) // searchCondition in ai chat panel has value when toggle using knowledge = on
        ? [tagSuggest, viewNameOfChatAI] 
        : []; // normal ai panel has keyword, tagSuggest, viewName. pks has qaCategory, tagGroup, selectTag will add in BE

    const searchCondition = valuesOfSearchCondition
        .filter(i => i)
        .reduce((value, i) => {
            return value+=`${i} `;
        }, '');

    data.searchCondition = searchCondition.trim()

    // send qaCategory and tagFieldsSelected to backend with case send from robo chat in pks
    if(screen == LogKibanaConstant.AI_CHAT_SCREEN.ROBO){
        data.qaCategoryId = qaCategoryId;
        data.tagFieldsSelected = tagFieldsSelected;
    }

    const logData = new InteractChatAIDto(data);
    return logData;
};

export const createKibanaReferencesAsAIPrompt = async dataLog => {
    const {
        rootCorporationDetailId,
        rootProjectDetail,
        corporationDetail,
        projectDetail,
        userDetail,
        API
    } = dataLog;

    let data = {};
    data.actionType = LogKibanaConstant.ACTION_TYPE.CONTENT_OPERATION;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.REFERENCES_AS_AI_PROMPT;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();

    //get in server
    data.destinationOrgId = rootCorporationDetailId;
    data.destinationOrgDomain = '';
    data.destinationOrgName = '';

    data.destinationPrjId = rootProjectDetail.id;
    data.destinationPrjName = Utils.getTextByLanguage(
        Constant.LANGUAGE_TYPE.JP,
        rootProjectDetail.name
    );

    data.orgActionId = corporationDetail.affiliationOrganization;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;

    data.prjActionId = projectDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail.name);

    data.userActionId = userDetail.id;
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail);

    data.contentTypes = LogKibanaConstant.CONTENT_TYPE.KNOWLEDGE;
    data.ticketId = dataLog.ticketId;
    data.ticketName = dataLog.ticketName;
    
    const logData = new ReferencesAsAIPromptDto(data);
    let params = {
        logKibanaData: logData,
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.USE_AI_PROMPT
    }
    //get in server
    createKibanaLogAPI(API, params);
};

export const createKibanaDataEnquete = (dataLog, corporationDetail, projectInuseDetail) => {
    let data = {};
    data.actionType = LogKibanaConstant.ACTION_TYPE.KNOWLEDGE_ROBO;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.ENQUETE;
    data.qaCategory = dataLog.qaCategory;
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    data.destinationOrgId = corporationDetail.id;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.name;
    data.destinationPrjId = projectInuseDetail.id;
    data.destinationPrjName = projectInuseDetail.name;
    data.orgActionId = LogKibanaConstant.DUMMY_TEXT;
    data.orgActionDomain = '';
    data.orgActionName = '';
    data.prjActionId = LogKibanaConstant.DUMMY_TEXT;
    data.prjActionName = '';
    data.userActionId = LogKibanaConstant.DUMMY_TEXT;
    data.userActionEmail = '';
    data.userActionName = '';
    data.operationScreen = LogKibanaConstant.OPERATION_SCREEN.PUBLIC;
    data.enqueteResult = dataLog.enqueteResult;
    data.enqueteFor = dataLog.enqueteFor;
    data.tagGroup = dataLog.tagGroup || '';
    data.selectTag = dataLog.selectTag || '';
    data.aiChatInquiryText = dataLog.aiChatInquiryText || '';
    data.aiChatAnswerText = dataLog.aiChatAnswerText || '';
    data.searchCondition = dataLog.searchCondition || '';

    let logData = new KnowLedgeRoboEnqueteDto(data);
    
    return logData;
}

export const createKibanaDataAIChat = (dataLog, optionSearch, corporationDetail, projectInuseDetail, userDetail, projectIdKnowledgeSelected) => {
    let data = {};
    data.actionType = LogKibanaConstant.ACTION_TYPE.AI_CHAT;
    data.actionDetail = LogKibanaConstant.ACTION_DETAIL.KNOWLEDGE_SEARCH_CONDITION_SETTING;
    
    if (!Utils.isEmptyArray(optionSearch.keywordList)) {
        let keyword = [...optionSearch.keywordList].sort();
        data.keyword = keyword;
    } else {
        data.keyword = ''
    }
    data.keywordCondition = optionSearch.methodSearch;
    if(optionSearch.methodSearch === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        data.keywordCondition = Constant.SETTING_SEARCH_KEYWORD.K_NN;
    }
    data.searchTarget = optionSearch.attributeSearch === Constant.SETTING_SEARCH_KEYWORD.MUTIPLE ? LogKibanaConstant.SEARCH_TARGET.BODY : LogKibanaConstant.SEARCH_TARGET.CHAT;
    let tagSuggest = '';
    if (!Utils.isEmptyArray(dataLog.searchTagSuggestKnowledge)) {
        let listTagSuggest = [...dataLog.searchTagSuggestKnowledge].sort();
        for (let i = 0; i < listTagSuggest.length; i++) {
            tagSuggest += listTagSuggest[i] + ' ';
        }
    }
    data.tag = tagSuggest;
    data.viewName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, dataLog.viewName);
    data.actionDate = new Date().toISOString();
    data.sessionId = getSession();
    data.destinationOrgId = corporationDetail.id;
    data.destinationOrgDomain = corporationDetail.organizationDomain;
    data.destinationOrgName = corporationDetail.corporationName;
    if (dataLog.corporationSelectedId) {
        data.destinationOrgId = dataLog.corporationSelectedId;
        data.destinationOrgDomain = '';
        data.destinationOrgName = '';
    }
    data.destinationPrjId = dataLog.projectSelectedId ? dataLog.projectSelectedId : projectInuseDetail.id;
    data.destinationPrjName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    if (dataLog.projectSelectedId) {
        data.destinationPrjId = dataLog.projectSelectedId;
        data.destinationPrjName = "";
    }
    data.orgActionId =  corporationDetail.id;
    data.orgActionDomain = corporationDetail.organizationDomain;
    data.orgActionName = corporationDetail.corporationName;
    data.prjActionId =  projectInuseDetail.id;
    data.prjActionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectInuseDetail.name);
    data.userActionId =  userDetail.id;
    data.userActionEmail = userDetail.mail;
    data.userActionName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)?.trim();
    data.hitNumber = dataLog.hitNumber;
    data.aiTabChatName = dataLog.aiTabChatName;
    let searchCondition =`${data.keyword} ${tagSuggest}`.trim() + ' ' + data.viewName;

    if (projectIdKnowledgeSelected === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
        searchCondition = `${data.keyword} ${tagSuggest}`.trim();
    }
    
    switch (dataLog.aiChatActionType) {
        case LogKibanaConstant.AI_CHAT_ACTION_TYPE.USING_KNOWLEDGE_TICKET_LIST:
        case LogKibanaConstant.AI_CHAT_ACTION_TYPE.UPDATE_SEARCH_CONDITION:
            data.searchTarget = LogKibanaConstant.SEARCH_TARGET.BODY;
            break;
        case LogKibanaConstant.AI_CHAT_ACTION_TYPE.NOT_USING_KNOWLEDGE_TICKET_LIST:
            searchCondition = '';
            data.searchTarget = null;
            break;
        default:
            break;
    }

    data.searchCondition = searchCondition.trim();

    let logData = new ChatAISearchConditionSettingDto(data);
    return logData;
}

export const getOptionsSearch = (filterKnowledgeListData) => {
    let keywordSearch = '';
    // Replace JP space
    if (filterKnowledgeListData.viewStructure?.keyword) {
        keywordSearch = filterKnowledgeListData.viewStructure?.keyword
            ?.toString()
            .replace(/\s+/g, ' ');
    }

    // optionSearch (keyword, method(AND/OR), target search(outline,...),....);
    let optionSearch = {
        methodSearch: filterKnowledgeListData.viewStructure?.options?.method
            ? filterKnowledgeListData.viewStructure?.options?.method
            : Constant.SETTING_SEARCH_KEYWORD.AND,
        attributeSearch: filterKnowledgeListData.viewStructure?.options?.attribute
            ? filterKnowledgeListData.viewStructure?.options?.attribute
            : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
        keywordList: keywordSearch ? keywordSearch.split(' ') : [],
        formatSearch: ''
    };

    // Search by date / time
    let fromSearchDate;
    let toSearchDate;

    let agoUnit = '';
    if (
        filterKnowledgeListData.viewStructure.options?.searchDateType ===
        Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
    ) {
        agoUnit = filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
            ? filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
            : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
        let agoValue = filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
            ? filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
            : 0;
        let agoUnitTime =
            agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                ? 7 * 24 * 60 * 60 * 1000
                : 24 * 60 * 60 * 1000;

        // toSearchDate is today
        toSearchDate = moment(new Date()).format('YYYY/MM/DD');

        // 0 days ago
        if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY) {
            fromSearchDate = toSearchDate;
        } else if (
            !agoValue &&
            agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
        ) {
            // 0 week ago = monday - today
            fromSearchDate = moment()
                .startOf('isoweek')
                .format('YYYY/MM/DD');
        } else {
            fromSearchDate = moment(new Date() - agoValue * agoUnitTime).format('YYYY/MM/DD');
        }

        optionSearch.fromSearchDate = fromSearchDate;
        optionSearch.toSearchDate = toSearchDate;
    } else {
        if (filterKnowledgeListData.viewStructure.options?.from) {
            fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
            optionSearch.fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
        }

        if (filterKnowledgeListData.viewStructure.options?.to) {
            toSearchDate = filterKnowledgeListData.viewStructure.options.to;
            optionSearch.toSearchDate = filterKnowledgeListData.viewStructure.options.to;
        }

        if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
            // switch search date
            let newFromSearchDate = toSearchDate;
            let newToSearchDate = fromSearchDate;

            fromSearchDate = newFromSearchDate;
            toSearchDate = newToSearchDate;

            optionSearch.fromSearchDate = fromSearchDate;
            optionSearch.toSearchDate = toSearchDate;
        }
    }

    if (filterKnowledgeListData?.viewStructure?.options?.otherFields) {
        optionSearch.formatSearch = JSON.stringify(
            filterKnowledgeListData.viewStructure.options.otherFields
        );
    }

    // Sort
    optionSearch.sortType = filterKnowledgeListData?.viewStructure?.options?.hasOwnProperty('sort') && filterKnowledgeListData?.viewStructure?.options['sort']
        ? filterKnowledgeListData.viewStructure?.options['sort']
        : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

    if(filterKnowledgeListData.viewStructure?.options?.getListPdfPage){
        optionSearch.getListPdfPage = filterKnowledgeListData.viewStructure?.options?.getListPdfPage
    }

    if(!Utils.isEmptyString(filterKnowledgeListData.viewStructure?.options?.filePdfId)){
        optionSearch.filePdfId = filterKnowledgeListData.viewStructure?.options?.getListPdfPage
    }
    return optionSearch;
};

export const createDataGetHitNumber = (firstView, corporationDetail, projectInuseDetail, userDetail) => {
    let filterKnowledgeListData = {
        viewSelectedId: firstView?.id,
        viewSelected: firstView,
        viewStructure: Utils.convertJSONDataToObject(firstView?.structure),
    }
    const drillDownSearch = buildDrillDownSearchParam(filterKnowledgeListData?.viewStructure);

    let optionSearchData = getOptionsSearch(filterKnowledgeListData);
    const dataDto = {
        corporationId: corporationDetail.id,
        projectId: projectInuseDetail.id,
        currentUserId: userDetail.id,
        visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
        visibilitySetting: 'new_arrived_knowledge',
        publicRange: null,
        projectInuse: projectInuseDetail.id,
        userAffiliationOrganization: userDetail.affiliationOrganization,
        projectInuseType: projectInuseDetail.type,
        viewId: filterKnowledgeListData?.viewSelectedId,
        optionSearch: optionSearchData,
        drillDownSearch: drillDownSearch,
        ticketIdList: [],
        ticketProperty: firstView?.viewStructure?.ticketProperty,
        resetSearchCondition: false,
        from: 0,
        size: 20
    };

    return dataDto;
}

export const getLastQaCategory = (listMsg) => {
    let qaCategory = '';
    for (let i = listMsg.length - 1; i >= 0 ; i--) {
        const element = listMsg[i];
        if (element.isFromMe) {
            qaCategory = element.content;
            break;
        }
    }
    return qaCategory;
}
